import $ from 'jquery';
import moment from 'moment/moment';

import { VIDEO_TIMESTAMP_CLASS } from 'constants/comments';

import { HHMMSS_REGEX, LOOSE_URL_REGEX_GLOBAL } from 'validate';

export const stripContent = medium => {
  const commentContent = replaceURLs(
    replaceVideoTimestamps(medium.value().trim())
  );

  return commentContent.replace(/<p>&nbsp;<\/p>/g, '');
};

const createAnchorLinkHtml = url => {
  const hrefVal = /^www/.test(url) ? `//${url}` : url;

  return `<a target="_blank" class="external-link" href="${hrefVal}">${url}</a>`;
};

export const replaceURLs = mediumContentHTML => {
  // first replace all video timestamps with their text contents so the regex
  // doesn't over-replace and nest timestamps
  const $strippedMediumContent = $('<div></div>').html(mediumContentHTML);

  $strippedMediumContent
    .find(`a:not(.${VIDEO_TIMESTAMP_CLASS})`)
    .replaceWith(function() {
      return $(this).text();
    });

  return $strippedMediumContent
    .html()
    .replace(LOOSE_URL_REGEX_GLOBAL, createAnchorLinkHtml);
};

export const replaceVideoTimestamps = mediumContentHTML => {
  // first replace all video timestamps with their text contents so the regex
  // doesn't over-replace and nest timestamps
  const $strippedMediumContent = $('<div></div>').html(mediumContentHTML);

  $strippedMediumContent
    .find(`.${VIDEO_TIMESTAMP_CLASS}`)
    .replaceWith(function() {
      return $(this).text();
    });

  return $strippedMediumContent.html().replace(HHMMSS_REGEX, timestamp => {
    let momentTimestamp = timestamp;

    // we must add the HH component if it doesn't exist
    if (momentTimestamp.split(':').length === 2) {
      momentTimestamp = `00:${timestamp}`;
    }

    const numSeconds = moment.duration(momentTimestamp).asSeconds();

    return [
      `<a href="#" class="${VIDEO_TIMESTAMP_CLASS}" data-seconds="${numSeconds}">`,
      `${timestamp}</a>`,
    ].join('');
  });
};
